import { render, staticRenderFns } from "./big-end-form.vue?vue&type=template&id=36a078b2&scoped=true&"
import script from "./big-end-form.vue?vue&type=script&lang=js&"
export * from "./big-end-form.vue?vue&type=script&lang=js&"
import style0 from "./big-end-form.vue?vue&type=style&index=0&id=36a078b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a078b2",
  null
  
)

export default component.exports